import { GET_CUSTOMERS } from "./customers.constants";

export const getCustomers = (payload = {}, callback) => ({type: GET_CUSTOMERS, payload, callback});